import React, { useState, useEffect, useCallback } from 'react'
import { Button, Checkbox, Col, DatePicker, Divider, Form, Image, Input, Modal, Row, Select, Space, Tooltip, Typography } from 'antd'
import { CopyOutlined, InboxOutlined } from '@ant-design/icons';
import { useAuthContext } from 'contexts/Auth'
import { useDropzone } from 'react-dropzone';
import PhoneInput from 'react-phone-input-2'
import axios from 'axios';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import PDF from './PDF';

import genders from 'data/genders.json'
import educations from 'data/educations.json'
import bloodGroups from 'data/bloodGroups.json'
import religions from 'data/religions.json'

import { Country, State, City } from 'country-state-city';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
const countries = Country.getAllCountries();

const { Title, Text } = Typography
const { Option } = Select

const initialCourse = { courseId: null, course: { type: "", title: "", abbreviation: "", batch: "", netFee: 0, paymentType: "", learningType: null, session: null } }
const initialState = {
    country: null, province: null, city: null,
    cnic: "", email: "", firstName: "", lastName: "",
    fatherName: "", fatherCNIC: "", gender: null, dob: "", age: "",
    phone: "", isSendSMS: false, whatsapp: "", education: null, bloodGroup: null, religion: null, address: "",
    ...initialCourse
}

const Add = () => {

    const { getApiConfig } = useAuthContext()

    const [isNew, setIsNew] = useState(true)
    const [state, setState] = useState(initialState)
    const [image, setImage] = useState(null)
    const [isImageVisible, setIsImageVisible] = useState(false)
    const [isProcessing, setIsProcessing] = useState(false)
    const [pdfData, setPdfData] = useState({})
    const [isAdmissionFormModalOpen, setIsAdmissionFormModalOpen] = useState(false)

    const [provinces, setProvinces] = useState([])
    const [cities, setCities] = useState([])
    // const [campuses, setCampuses] = useState([])
    const [courses, setCourses] = useState([])
    const [filteredCourses, setFilteredCourses] = useState([])
    const [selectedCourse, setSelectedCourse] = useState({})

    const [isLoading, setIsLoading] = useState({ courses: false })
    const params = useParams()

    // Dropzone
    const { getRootProps, getInputProps } = useDropzone({
        accept: { 'image/*': [] }, multiple: false,
        onDrop: acceptedFiles => { setImage(acceptedFiles[0]) }
    });

    const handleChange = e => setState(s => ({ ...s, [e.target.name]: e.target.value }))
    const handleLoading = (key, val) => setIsLoading(s => ({ ...s, [key]: val }))

    const readApplication = useCallback(async () => {
        axios.get(`${window.api}/applications/manage?cnic=${params.id}`, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === 200) {
                    setCourses(data.courses)
                    setFilteredCourses(data.courses)
                    if (params.id !== "add") {
                        setSelectedCourse(data.selectedCourse)
                        setState(s => ({ ...s, ...data.application }))
                        setIsNew(false)
                    }
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || "Something went wrong while getting the application", "error")
            })
    }, [params.id, getApiConfig])
    useEffect(() => { readApplication() }, [readApplication])

    const readStudent = useCallback(async () => {

        if (state.cnic.length !== 13) { return window.toastify('Please enter CNIC / B-form correctly', "error") }

        axios.get(`${window.api}/students/single-with-cnic/${state.cnic}`, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === 200) {
                    setState(s => ({ ...s, ...data.student }))
                }
            })
            .catch(error => {
                setState(s => ({ ...s, cnic: s.cnic }))
                // console.error(error)
                window.toastify(error.response?.data?.message || "Something went wrong while getting the student", "info")
            })
    }, [state.cnic, getApiConfig])

    // const readCampuses = useCallback(async () => {
    //     handleLoading("campuses", true)
    //     axios.get(`${window.api}/campuses/all`, getApiConfig())
    //         .then((res) => {
    //             const { data, status } = res
    //             if (status === 200) {
    //                 setCampuses(data.campuses)
    //             }
    //         })
    //         .catch(error => {
    //             console.error(error)
    //             window.toastify(error.response?.data?.message || "Something went wrong while getting the campuses", "error")
    //         })
    //         .finally(() => {
    //             handleLoading("campuses", false)
    //         })

    // }, [getApiConfig])
    // useEffect(() => { readCampuses() }, [readCampuses])

    // const handleCampus = (val) => {
    //     // const campus = campuses.find(campus => campus.id === val)
    //     setState(s => ({ ...s, campusId: val }))
    // }
    const handleCourse = (val) => {
        const course = courses.find(course => course.id === val)
        const { type, title, abbreviation, batch, netFee, paymentType } = course
        setState(s => ({ ...s, courseId: val, course: { type, title, abbreviation, batch, netFee, paymentType, learningType: null, session: null } }))
        setSelectedCourse(course)
    }

    const getSessions = () => {
        const { gender, courseId, course } = state
        if (gender && courseId && course.learningType) {
            const { learningTypes = [], } = selectedCourse
            const genderKey = gender === 'male' ? 'classSessionsForMales' : 'classSessionsForFemales';

            const formatSessions = [...new Set(selectedCourse?.[genderKey]?.filter(session => learningTypes.includes(session.type)).map(session => session.time))]
            return formatSessions;
        } else {
            return []
        }
    }
    const handleDOB = (dateObj, val) => {
        if (val) {
            const age = window.calculateAge(val)
            setState(s => ({ ...s, dob: val, age }))
        } else {
            setState(s => ({ ...s, dob: val, age: "" }))
        }
    }

    const handleGender = (val) => {
        setState(s => ({ ...s, gender: val }))
        setState(s => ({ ...s, ...initialCourse }))
        setFilteredCourses(courses.filter((course) => course.targetGenders.includes(val)))
        setSelectedCourse({})
    }

    const handleEducation = (val) => {
        // const education = educations.find(education => education.value === val)
        setState(s => ({ ...s, education: val }))
    }
    const handleBloodGroup = (val) => {
        // const bloodGroup = bloodGroups.find(bloodGroup => bloodGroup.value === val)
        setState(s => ({ ...s, bloodGroup: val }))
    }
    const handleReligion = (val) => {
        // const religion = religions.find(religion => religion.value === val)
        setState(s => ({ ...s, religion: val }))
    }
    const handleCountry = (val) => {
        const country = countries.find(country => country.isoCode === val)
        // console.log("country =>", country)
        setState(s => ({ ...s, country, province: null, city: null }))
    }
    useEffect(() => { setProvinces(State.getStatesOfCountry(state?.country?.isoCode)) }, [state.country])
    const handleProvince = (val) => {
        const province = provinces.find(province => province.isoCode === val)
        // console.log("province =>", province)
        setState(s => ({ ...s, province, city: null }))
    }
    useEffect(() => { setCities(City.getCitiesOfState(state?.country?.isoCode, state?.province?.isoCode)) }, [state?.country?.isoCode, state.province])
    const handleCity = (val) => {
        const city = cities.find(city => city.name === val)
        // console.log("city =>", city)
        setState(s => ({ ...s, city }))
    }
    // const handleDate = (name, val) => {
    //     setState(s => ({ ...s, [name]: val }))
    // }

    const handleSubmit = e => {
        e.preventDefault()

        let { country, province, city, cnic, email, firstName, lastName, fatherName, fatherCNIC, gender, dob, age, phone, isSendSMS, whatsapp, education, bloodGroup, religion, address, photoURL, photoPublicId, courseId, course } = state
        firstName = firstName.trim()
        lastName = lastName.trim()
        let fullName = firstName + " " + lastName
        fullName = fullName.trim()

        fatherName = fatherName.trim()
        fatherCNIC = window.getValidCNIC(fatherCNIC)
        cnic = window.getValidCNIC(cnic)
        phone = phone.trim()
        whatsapp = whatsapp.trim()
        address = address.trim()

        if (!country) { return window.toastify('Please select country', "error") }
        if (!province) { return window.toastify('Please select province', "error") }
        if (!city) { return window.toastify('Please select city', "error") }
        if (cnic.length !== 13) { return window.toastify('Please enter CNIC / B-form correctly', "error") }
        if (!window.isEmail(email)) { return window.toastify('Please enter a valid email address', "error") }
        if (firstName.length < 3) { return window.toastify('Please enter first name', "error") }
        if (fatherName.length < 3) { return window.toastify("Please enter father's name", "error") }
        // if (fatherCNIC.length !== 13) { return window.toastify("Please enter father's CNIC correctly", "error") }
        if (!gender) { return window.toastify('Please select gender', "error") }
        if (!dob) { return window.toastify('Please select date of birth', "error") }
        if (!phone) { return window.toastify('Please enter phone number', "error") }
        if (phone.charAt(0) === "0" || whatsapp.charAt(0) === "0") { return window.toastify("Phone number or WhatsApp can't be start with 0. Please start it with country code", "error") }
        if (phone.slice(0, 2) === "92" && phone.length !== 12) { return window.toastify("Please enter phone number correctly", "error") } // Only for Pakistan
        if (!whatsapp) { return window.toastify('Please enter whatsapp number', "error") }
        if (whatsapp.slice(0, 2) === "92" && whatsapp.length !== 12) { return window.toastify("Please enter whatsapp number correctly", "error") } // Only for Pakistan
        if (!education) { return window.toastify('Please select education/highest qualification', "error") }
        if (!bloodGroup) { return window.toastify('Please select blood group', "error") }
        if (!religion) { return window.toastify('Please select religion', "error") }
        if (address.length < 6) { return window.toastify('Please enter a valid address', "error") }
        // if (!image && !state.photoURL) { return window.toastify("Please upload student photo", "error") }
        // if (image && image.size > 1048576) { return window.toastify("File size should be less than 1MB", "error") }
        if (!courseId) { return window.toastify('Please select course', "error") }

        country = JSON.stringify(country)
        province = JSON.stringify(province)
        city = JSON.stringify(city)
        course = JSON.stringify(course)

        let data = {
            country, province, city, cnic, email, firstName, lastName, fullName, fatherName, fatherCNIC, gender, dob, age, phone, isSendSMS, whatsapp, education, bloodGroup, religion, address, photoURL, photoPublicId,
            courseId, course,
        }

        const formData = new FormData()
        for (const key in data) { formData.append(key, data[key]); }
        if (image) { formData.append('image', image) }

        setIsProcessing(true)
        createDocument(formData)
    }

    const createDocument = async (formData) => {

        axios[isNew ? "post" : "patch"](`${window.api}/applications/${isNew ? "add" : `update/${state.id}`}`, formData, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === isNew ? 201 : 200) {
                    window.toastify(data.message, "success")
                    setPdfData(data.application)
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || `Something went wrong while ${isNew ? "adding a new" : "updating the"} application`, "error")
            })
            .finally(() => {
                setIsProcessing(false)
            })

    }

    const pdf = <PDF data={pdfData} />

    return (
        <>
            <Row className='mb-4'>
                <Col>
                    <Title level={3} className="mb-0">Applications</Title>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card">
                        <Row className='mb-4'>
                            <Col>
                                <Title level={4} className="mb-0">{isNew ? "Add New" : "Update"} Applicant</Title>
                            </Col>
                        </Row>
                        <Form layout='vertical'>
                            <Row gutter={16}>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Country" required>
                                        <Select
                                            showSearch
                                            placeholder="Select country"
                                            onChange={handleCountry}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.country?.isoCode}
                                        >
                                            {countries.map((item, i) => <Option key={i} value={item.isoCode}>{item.name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Province" required>
                                        <Select
                                            showSearch
                                            placeholder="Select province"
                                            onChange={handleProvince}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.province?.isoCode}
                                            disabled={!state.country}
                                        >
                                            {provinces.map((item, i) => <Option key={i} value={item.isoCode}>{item.name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="City" required>
                                        <Select
                                            showSearch
                                            placeholder="Select city"
                                            onChange={handleCity}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.city?.name}
                                            disabled={!state.country || !state.province}
                                        >
                                            {cities.map(item => <Option key={item.name} value={item.name}>{item.name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                {/* <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Campus" required>
                                        <Select
                                            showSearch
                                            placeholder="Select a campus"
                                            onChange={handleCampus}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.campusId}
                                            loading={isLoading.campuses}
                                        >
                                            {campuses.map(campus => <Option key={campus.id} value={campus.id}>{campus.name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col> */}
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="CNIC/B-Form" required>
                                        <Input placeholder="Student CNIC / B-Form" maxLength={13} name="cnic" value={state.cnic} onChange={handleChange} onBlur={readStudent} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Email" required>
                                        <Input placeholder="Email" name="email" value={state.email} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="First name" required>
                                        <Input placeholder="First name" name="firstName" value={state.firstName} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Last name">
                                        <Input placeholder="Last name" name="lastName" value={state.lastName} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Father name" required>
                                        <Input placeholder="Father name" name="fatherName" value={state.fatherName} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Father CNIC">
                                        <Input placeholder="Father CNIC" name="fatherCNIC" maxLength={13} value={state.fatherCNIC} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Gender" required>
                                        <Select
                                            showSearch
                                            placeholder="Select a gender"
                                            onChange={handleGender}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={genders}
                                            value={state.gender}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Date of birth" required>
                                        <Space.Compact className='w-100'>
                                            <DatePicker className='w-100' value={state.dob ? dayjs(state.dob) : null} onChange={handleDOB}
                                                disabledDate={(current) => window.disabledDate(current, "future")}
                                            />
                                            <Tooltip title="Age"><Button className='btn-age' disabled>{state.age}</Button></Tooltip>
                                        </Space.Compact>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} xl={6}>
                                    <Form.Item label="Phone number" required>
                                        <Space.Compact className='w-100'>
                                            <PhoneInput
                                                country={'pk'}
                                                value={state.phone}
                                                onChange={phone => setState(s => ({ ...s, phone }))}
                                                inputStyle={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                            />
                                            <Tooltip title="Send SMS">
                                                <Button className='p-0 px-2'><Checkbox checked={state.isSendSMS} onChange={e => setState(s => ({ ...s, isSendSMS: e.target.checked }))} /></Button>
                                            </Tooltip>
                                        </Space.Compact>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} xl={6}>
                                    <Form.Item label="WhatsApp" required>
                                        <Space.Compact className='w-100'>
                                            <PhoneInput
                                                country={'pk'}
                                                value={state.whatsapp}
                                                onChange={whatsapp => setState(s => ({ ...s, whatsapp }))}
                                                inputStyle={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                            />
                                            <Tooltip title="Copy Phone Number">
                                                <Button onClick={() => { setState(s => ({ ...s, whatsapp: s.phone })) }} icon={<CopyOutlined />} />
                                            </Tooltip>
                                        </Space.Compact>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} lg={12} xl={6}>
                                    <Form.Item label="Education" required>
                                        <Select
                                            showSearch
                                            placeholder="Select highest education/qualification"
                                            onChange={handleEducation}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={educations}
                                            value={state.education}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6} xl={3}>
                                    <Form.Item label="Blood Group" required>
                                        <Select
                                            showSearch
                                            placeholder="Select blood group"
                                            onChange={handleBloodGroup}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={bloodGroups}
                                            value={state.bloodGroup}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6} xl={3}>
                                    <Form.Item label="Religion" required>
                                        <Select
                                            showSearch
                                            placeholder="Select religion"
                                            onChange={handleReligion}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={religions}
                                            value={state.religion}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} className='mb-md-0'>
                                    <Form.Item label="Address" required>
                                        <Input.TextArea rows={5} style={{ resize: "none" }} placeholder="Address" name="address" maxLength={100} showCount value={state.address} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label="Student Photo (512px X 512px)" required className='mb-0'>
                                        <>
                                            <div {...getRootProps({ className: 'dropzone' })}>
                                                <InboxOutlined />
                                                <input {...getInputProps()} />
                                                <p>Click or drag file</p>
                                            </div>
                                            {(image || state.photoURL) && <Text className='text-primary cursor-pointer text-decoration-underline' onClick={() => { setIsImageVisible(true) }}>Click to view photo</Text>}
                                        </>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Divider orientation='left'><Title level={5}>Course/Training Details</Title></Divider>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Course" required>
                                        <Select
                                            showSearch
                                            placeholder="Select a course"
                                            onChange={handleCourse}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.courseId}
                                            disabled={!state.gender}
                                        >
                                            {filteredCourses.map(course => <Option key={course.id} value={course.id}>{course.title}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Batch" required>
                                        <Input placeholder="Batch" name="batch" value={state.course.batch} readOnly disabled={!state.courseId} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Learning Type" required>
                                        <Select
                                            showSearch
                                            placeholder="Select a learning type"
                                            onChange={value => setState(s => ({ ...s, course: { ...s.course, learningType: value, session: null } }))}
                                            filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
                                            value={state.course.learningType ? window.toCapitalizeCase(state.course.learningType) : null}
                                            disabled={!state.course.batch}
                                        >
                                            {selectedCourse.learningTypes?.map(type => <Option key={type} value={type} className="text-capitalize">{type}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Session" required>
                                        <Select
                                            showSearch
                                            placeholder="Select a session"
                                            onChange={value => setState(s => ({ ...s, course: { ...s.course, session: value } }))}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.course.session}
                                            disabled={!state.course.learningType}
                                        >
                                            {getSessions().map((session, i) => <Option key={i} value={session} className="text-capitalize">{session}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='text-end'>
                                    <Space size="small">
                                        {pdfData.firstName &&
                                            <>
                                                <button type='button' className="btn btn-info btn-sm" disabled={isProcessing} onClick={() => setIsAdmissionFormModalOpen(true)}>Print Form</button>
                                                <PDFDownloadLink document={pdf} fileName={`${pdfData.firstName} - Admission Form - ${"CoDev"}`}>
                                                    {({ blob, url, loading, error }) => {
                                                        return <button type='button' className="btn btn-success btn-sm" disabled={isProcessing || loading}>
                                                            {!loading
                                                                ? <span>Download Form</span>
                                                                : <span className="spinner-grow spinner-grow-sm"></span>
                                                            }
                                                        </button>
                                                    }}
                                                </PDFDownloadLink>
                                            </>
                                        }
                                        <Button type='primary' loading={isProcessing} onClick={handleSubmit}>{isNew ? "Add" : "Update"}</Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Col>
            </Row>

            <Modal title="Admission Form" centered open={isAdmissionFormModalOpen} onCancel={() => setIsAdmissionFormModalOpen(false)} footer={null}>
                <PDFViewer width="100%" height="700">{pdf}</PDFViewer>
            </Modal>

            {(image || state.photoURL) && <Image preview={{ visible: isImageVisible, src: image ? URL.createObjectURL(image) : state.photoURL, onVisibleChange: (value) => { setIsImageVisible(value) } }} />}
        </>
    )
}

export default Add